// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3WIkf","errorLogs":"styles_errorLogs__n0DMq"};